import { Component, inject } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { AnlagenAnschrift } from '../../../domain/model/anlagen-anschrift.model';
import { AbstractForm } from '../abstract-form.model';
import { FormGroupConfig } from '../form-config.model';
import { PostalCodeValidator } from '../validator/postal-code.validator';
import { ErzeugungsanlageConfig } from '../erzeugungsanlage.config';
import { MatValidators } from '../../../common/material/components/mat-form-field-required.directive';
import { Feld } from '../../../domain/model/feld.enum';
import { PostalCodeType } from '../../../domain/model/postal-code-type.enum';

@Component({
    selector: 'redispatch-anlagen-anschrift-sub-form',
    templateUrl: './anlagen-anschrift-sub-form.component.html',
    styleUrls: [
        './anlagen-anschrift-sub-form.component.scss',
    ],
    standalone: false,
})
export class AnlagenAnschriftSubFormComponent extends AbstractForm<AnlagenAnschrift> {

    public readonly LYT_GAP = ErzeugungsanlageConfig.HORIZONTAL_FX_LAYOUT_GAP;

    public readonly GEMEINDE_MAX_LENGTH = 255;
    public readonly Feld = Feld;

    constructor() {
        super(inject(UntypedFormBuilder));
    }

    get formGroupConfig(): FormGroupConfig<AnlagenAnschrift> {
        return {
            plz: [
                '',
                [
                    MatValidators.required,
                    PostalCodeValidator.validate(PostalCodeType.GERMAN),
                ],
            ],
            gemeinde: [
                '',
                [
                    MatValidators.required,
                    Validators.maxLength(this.GEMEINDE_MAX_LENGTH),
                ],
            ],
            strasse: [
                '',
            ],
            hausnr: [
                '',
            ],
            hausnrZusatz: [
                '',
            ],
        };
    }

    public sanitize(anschrift: AnlagenAnschrift): AnlagenAnschrift {
        return anschrift;
    }

}
